/* Mikiri features: recently viewed, My collection, sticky add-to-cart (mobile). No external requests except this store's own product JSON. */
(function () {
  'use strict';
  var C = window.mkConfig || { t: {} };
  var T = C.t || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function load(key, fallback) {
    try { var v = window.localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
  }
  function save(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode: features just don't persist */ }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var fmt = C.moneyFormat || '{{amount}} GEL';
    var n = (cents || 0) / 100;
    var two = n.toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, two)
      .replace(/<[^>]*>/g, '');
  }

  var pdata = null;
  var pEl = document.getElementById('mk-pdata');
  if (pEl) { try { pdata = JSON.parse(pEl.textContent); } catch (e) { pdata = null; } }

  /* ---------- Recently viewed ---------- */
  var RV = 'mk_recent';
  var recent = load(RV, []);
  if (!Array.isArray(recent)) recent = [];
  var current = pdata && pdata.handle;
  if (current) {
    recent = [current].concat(recent.filter(function (h) { return h !== current; })).slice(0, 12);
    save(RV, recent);
  }

  function card(p) {
    var img = p.featured_image || '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var ratio = p.media && p.media[0] && p.media[0].aspect_ratio;
    var shape = ratio && ratio > 0.72 ? 'is-object' : 'is-cover';
    var sold = !p.available;
    return '<a href="' + esc(root + 'products/' + p.handle) + '" class="mk-card' + (sold ? ' is-soldout' : '') + '">' +
      '<span class="mk-card__mat ' + shape + '">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="400">' : '') +
      '</span>' +
      '<span class="mk-card__title">' + esc(p.title) + '</span>' +
      '<span class="mk-card__meta"><span class="mk-card__price">' + esc(money(p.price)) + '</span>' +
      (sold ? '<span class="mk-card__stock">' + esc(T.soldOut || 'Sold out') + '</span>' : '') +
      '</span></a>';
  }

  var box = document.querySelector('[data-mk-recent]');
  if (box && window.fetch) {
    var list = recent.filter(function (h) { return h !== current; }).slice(0, 10);
    if (list.length) {
      Promise.all(list.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var found = products.filter(Boolean);
        var missing = list.filter(function (h, i) { return !products[i]; });
        if (missing.length) {
          save(RV, load(RV, []).filter(function (h) { return missing.indexOf(h) === -1; }));
        }
        if (!found.length) return;
        box.querySelector('[data-mk-recent-grid]').innerHTML = found.map(card).join('');
        box.hidden = false;
      });
    }
  }

  /* ---------- My collection ("I own this") ---------- */
  var SH = 'mk_collection';
  function owned() { var s = load(SH, []); return Array.isArray(s) ? s : []; }
  function isOwned(id) { return owned().indexOf(String(id)) > -1; }

  function markSeries() {
    var groups = document.querySelectorAll('.mk-ro__group');
    var anyOwned = false;
    Array.prototype.forEach.call(groups, function (g) {
      var chips = Array.prototype.slice.call(g.querySelectorAll('.mk-ro__chip[data-pid]'));
      var last = -1;
      chips.forEach(function (c, i) {
        var o = isOwned(c.getAttribute('data-pid'));
        c.classList.toggle('is-owned', o);
        c.classList.remove('is-next');
        if (o) { last = i; anyOwned = true; }
      });
      var old = g.querySelector('.mk-ro__next');
      if (old) old.parentNode.removeChild(old);
      if (last > -1) {
        for (var i = last + 1; i < chips.length; i++) {
          if (!isOwned(chips[i].getAttribute('data-pid'))) {
            chips[i].classList.add('is-next');
            var a = document.createElement('a');
            a.className = 'mk-ro__next';
            a.href = chips[i].getAttribute('href');
            a.textContent = (T.next || 'Your next: Vol. {n} →').replace('{n}', chips[i].textContent.trim());
            var label = g.querySelector('.mk-ro__label');
            if (label && label.parentNode) label.parentNode.insertBefore(a, label.nextSibling);
            break;
          }
        }
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.mk-ro__legend'), function (lg) {
      var item = lg.querySelector('[data-mk-legend-owned]');
      if (anyOwned && !item) {
        item = document.createElement('span');
        item.setAttribute('data-mk-legend-owned', '');
        item.innerHTML = ' <i class="is-owned"></i>' + esc(T.owned || 'In my collection');
        lg.appendChild(item);
      } else if (!anyOwned && item) {
        item.parentNode.removeChild(item);
      }
    });
  }

  var ownBtn = document.querySelector('[data-mk-own]');
  if (ownBtn) {
    var pid = String(ownBtn.getAttribute('data-pid'));
    var syncOwn = function () {
      var on = isOwned(pid);
      ownBtn.classList.toggle('is-on', on);
      ownBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    };
    ownBtn.hidden = false;
    syncOwn();
    ownBtn.addEventListener('click', function () {
      var s = owned();
      if (s.indexOf(pid) > -1) { s = s.filter(function (x) { return x !== pid; }); } else { s.push(pid); }
      save(SH, s);
      syncOwn();
      markSeries();
    });
  }
  markSeries();

  /* ---------- Sticky add to cart (mobile, via CSS) ---------- */
  var mainBtn = document.querySelector('[id^="MainProduct-"] .product-form__submit');
  if (mainBtn && pdata && 'IntersectionObserver' in window) {
    var bar = document.createElement('div');
    bar.className = 'mk-sticky';
    bar.setAttribute('aria-hidden', 'true');
    var titleEl = document.querySelector('[id^="MainProduct-"] .product__title h1');
    bar.innerHTML = '<div class="mk-sticky__info"><span class="mk-sticky__title"></span><span class="mk-sticky__price"></span></div>' +
      '<button type="button" class="mk-sticky__btn" tabindex="-1"></button>';
    bar.querySelector('.mk-sticky__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    bar.querySelector('.mk-sticky__price').textContent = pdata.price || '';
    var sBtn = bar.querySelector('.mk-sticky__btn');
    document.body.appendChild(bar);

    var syncBar = function () {
      var span = mainBtn.querySelector('span');
      sBtn.textContent = (span ? span.textContent : mainBtn.textContent).trim();
      var off = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      bar.classList.toggle('is-disabled', off);
      if (off) document.body.classList.remove('mk-has-sticky');
    };
    syncBar();
    new MutationObserver(syncBar).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    sBtn.addEventListener('click', function () { if (!mainBtn.disabled) mainBtn.click(); });

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('mk-has-sticky', show && !bar.classList.contains('is-disabled') && window.matchMedia('(max-width: 749px)').matches);
    }).observe(mainBtn);
  }
})();
